/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateIndicatorScoreRequest } from '../models/CreateIndicatorScoreRequest';
import type { CreateIndicatorScoreResponse } from '../models/CreateIndicatorScoreResponse';
import type { GetIndicatorScoreResponse } from '../models/GetIndicatorScoreResponse';
import type { IndicatorScore } from '../models/IndicatorScore';
import type { UpdateIndicatorScoreRequest } from '../models/UpdateIndicatorScoreRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IndicatorScoreService {

    /**
     * Create a new indicator score.
     * @param requestBody The request to create an indicator score.
     * @returns CreateIndicatorScoreResponse OK
     * @throws ApiError
     */
    public static createIndicatorScore(
        requestBody?: CreateIndicatorScoreRequest,
    ): CancelablePromise<CreateIndicatorScoreResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/indicatorscores/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a specific score logic entry.
     * @param organizationId The ID of the organization.
     * @param indicatorscoreId The ID of the indicator score entry to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteIndicatorScore(
        organizationId: string,
        indicatorscoreId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/indicatorscore/{organizationId}/{indicatorscoreId}',
            path: {
                'organizationId': organizationId,
                'indicatorscoreId': indicatorscoreId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve a specific indicator score using scoreIndicatorId and organizationId.
     * @param scoreIndicatorId The ID of the score indicator to retrieve the indicator score for.
     * @param organizationId The ID of the organization to scope the indicator score for.
     * @returns GetIndicatorScoreResponse OK
     * @throws ApiError
     */
    public static getIndicatorScore(
        scoreIndicatorId: string,
        organizationId: string,
    ): CancelablePromise<GetIndicatorScoreResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/indicatorscores/{organizationId}/{scoreIndicatorId}',
            path: {
                'scoreIndicatorId': scoreIndicatorId,
                'organizationId': organizationId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Update an existing indicator score.
     * @param requestBody The request to update an indicator score.
     * @returns IndicatorScore OK
     * @throws ApiError
     */
    public static updateIndicatorScore(
        requestBody?: UpdateIndicatorScoreRequest,
    ): CancelablePromise<IndicatorScore> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/indicatorscores/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Retrieve all indicator scores for the specified organization.
     * @param organizationId The ID of the organization to scope the indicator scores for.
     * @returns IndicatorScore OK
     * @throws ApiError
     */
    public static getIndicatorScores(
        organizationId: string,
    ): CancelablePromise<Array<IndicatorScore>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/indicatorscores/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
